import React, { FC } from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

import { LoaderProps } from './Loader.types'
import Logo from './Logo'
import { createStyles, makeStyles } from '@material-ui/core'

export const Loader: FC<LoaderProps> = ({ percentLoaded }) => {
  const classes = useStyles()

  return (
    <div id='loadingpage' className={classes.loader} data-testid='Loader'>
      <Logo />
      {percentLoaded !== undefined ? (
        <CircularProgress size={300} thickness={1} value={percentLoaded} variant={'determinate'} />
      ) : (
        <CircularProgress size={300} thickness={1} />
      )}
    </div>
  )
}

const useStyles = makeStyles(() =>
  createStyles({
    loader: {
      position: 'absolute',
      width: '100vw',
      height: '100vh',
      top: '0',
      backgroundColor: 'black',
      zIndex: 3,

      '& svg': {
        height: 'auto',
        width: '175px',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
      },

      '& .MuiCircularProgress-root': {
        position: 'absolute',
        width: '300px',
        height: '300px',
        top: 'calc(50% - 150px)',
        left: 'calc(50% - 150px)',

        '& svg': {
          height: '100%',
          width: '100%',
          color: '#fff'
        }
      }
    }
  })
)
